<!--
 * @Description: 列表标题和搜索
 * @Author: 徐强
 * @Date: 2021-11-03 10:20:14
-->
<template>
  <el-row>
    <div class="nav-search">
      <div>
        <div class="left-logo" :style=" color ? { 'background-color': color } : { 'background-color': '#1890ff' } " />
        <slot name="leftTitle">
          <span style="font-weight: 600;">{{ title }}</span>
        </slot>
      </div>
      <div style="display: flex">
        <slot name="rightLogic">
          <el-input v-model="keyword" :placeholder="placeholder?placeholder:'请输入关键字'" class="right-input" autocomplete="off" @keyup.enter.native="query('keyword')">
            <i slot="suffix" class="el-input__icon el-icon-search" @click="query('keyword')" />
          </el-input>
          <el-link type="primary" :underline="false" style="margin:0px 15px;" @click="drawer=true">高级搜索<i class="icon-search iconfont  icon" aria-hidden="true" /></el-link>
        </slot>
      </div>
    </div>
    <el-drawer title="高级检索" :visible.sync="drawer" direction="rtl" size="430px" class="drawerContent">
      <div style="color: #0177D5;text-align:center;font-size: 14px;margin-bottom:25px">添加条件</div>
      <div style="padding: 0 26px;margin-bottom:20px">
        <el-checkbox-group v-model="formColumns" class="checkbox-group" @change="addCondition">
          <el-checkbox-button v-for="(item, index) of columns" :key="index" :label="item" class="checkbox-btn">{{ item.label }}</el-checkbox-button>
        </el-checkbox-group>
      </div>
      <div style="color: #0177D5;text-align:center;font-size: 14px;margin-bottom:25px">搜索条件</div>
      <div style="padding: 0 26px;margin-bottom:20px">
        <el-form ref="form" :model="form" label-width="110px">
          <template v-for="(item,index) of formColumns">
            <el-form-item v-if="item.type==='input'" :key="index" :label="item.label+':'">
              <el-input v-model="item.value" />
            </el-form-item>
            <el-form-item v-else-if="item.type==='select'" :key="index" :label="item.label+':'">
              <el-select v-model="item.value" placeholder="请选择" multiple collapse-tags style="width: 100%;">
                <el-option v-for="(select,i) in item.data" :key="i" :label="select.label" :value="select.value" />
              </el-select>
            </el-form-item>
            <el-form-item v-else-if="item.type==='date'" :key="index" :label="item.label+':'">
              <el-date-picker v-model="item.value" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 100%;" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" />
            </el-form-item>
          </template>
        </el-form>
      </div>
      <div style="display: flex;justify-content: center;">
        <el-button size="small" style="width: 120px;" @click="resetForm('ruleForm')">重 置</el-button>
        <el-button type="primary" style="width: 120px;" size="small" @click="query('object')">查 询</el-button>
      </div>
    </el-drawer>
  </el-row>
</template>
<script>
export default {
  name: "TableElement",
  props: {
    title: {
      type: String,
      default: function() {
        return "";
      }
    },
    color: {
      type: String,
      default: function() {
        return "";
      }
    },
    placeholder: {
      type: String,
      default: function() {
        return "";
      }
    },
    columns: { // 展示数据
      type: Array,
      default: function() {
        return [];
      }
    },
  },
  data() {
    return {
      keyword: "",
      drawer: false,
      form: {},
      formColumns: [],
    }
  },
  mounted() { },
  methods: {
    addCondition(data) {
      this.columns.forEach(element => {
        let res = true
        this.formColumns.forEach(item => {
          if (element.pram === item.pram) {
            res = false
          }
        });
        if (res) {
          if (element.type === 'input') {
            this.$set(element, 'value', '')
          } else {
            this.$set(element, 'value', [])
          }
        }
      });
    },
    query(pram) {
      const queryParam = {}
      if (pram === 'object') {
        this.formColumns.forEach(element => {
          if (element.value && element.value !== "" && element.value.length > 0) {
            this.$set(queryParam, element.pram, element.value)
          }
        });
      } else {
        this.$set(queryParam, 'keyword', this.keyword)
      }

      console.log(queryParam)
    },
  }
}
</script>

<style lang="scss" scoped>
.nav-search {
  line-height: 60px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e8e8e8;
}
.left-logo {
  width: 3px;
  margin-right: 10px;
  float: left;
  height: 22px;
  margin-top: 19px;
}
.right-input {
  float: right;
  width: 200px;
  margin-left: 10px;
}
.el-icon-search {
  cursor: pointer;
  color: #1890ff;
  font-size: 17px;
  font-weight: 800;
}
.drawerContent {
  ::v-deep .el-drawer__container .el-drawer .el-drawer__header {
    font-size: 15px;
    color: #333333;
    padding: 10px 20px;
    border-bottom: 2px solid #ebebeb;
    margin-bottom: 30px;
  }
}
.checkbox-btn {
  margin: 0 8px 15px 8px;
  ::v-deep .el-checkbox-button__inner {
    width: 110px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 10px 0;
    text-align: center;
  }
  ::v-deep .el-checkbox-button.is-checked .el-checkbox-button__inner {
    background-color: #fff;
  }
}
.checkbox-group {
  ::v-deep.is-checked .el-checkbox-button__inner {
    border: 1px solid #1890ff;
  }
}
</style>

